import { z } from "zod";

const translationPath = "page.settings.siteApp.siteAppCheckIn.errors.";

export const siteAppCheckInSchema = z.object({
  id: z.string().optional(),
  time: z.string().min(1, translationPath + "time"),
  metersApproximation: z
    .string()
    .min(1, translationPath + "meters_approximation"),
  latitude: z.string().min(1, translationPath + "latitude"),
  longitude: z.string().min(1, translationPath + "longitude"),
  sectorCode: z
    .string({
      invalid_type_error: translationPath + "standard_service_sector_code",
    })
    .min(1, translationPath + "standard_service_sector_code"),
  unityCode: z
    .string({
      invalid_type_error: translationPath + "standard_service_unit",
    })
    .min(1, translationPath + "standard_service_unit"),
  patientEncounterOriginCode: z
    .string({
      invalid_type_error: translationPath + "patient_encounter_origin_code",
    })
    .min(1, translationPath + "patient_encounter_origin_code"),
  sectorAccommodationType: z
    .string({
      invalid_type_error: translationPath + "sector_accommodation_type",
    })
    .min(1, translationPath + "sector_accommodation_type"),
  patientEncounterPhysicianCode: z
    .string({
      invalid_type_error: translationPath + "patient_encounter_physician_code",
    })
    .min(1, translationPath + "patient_encounter_physician_code"),
  patientEncounterTypeCode: z
    .string({
      invalid_type_error: translationPath + "patient_encounter_type_code",
    })
    .min(1, translationPath + "patient_encounter_type_code"),
  insuranceAllowCheckin: z.string().nullish(),
});

export type TSiteAppCheckInForm = z.infer<typeof siteAppCheckInSchema>;
